import { Link } from 'react-router-dom';
import googlePayMark from '@/assets/google-pay-mark.png';
import samsungPay from '@/assets/samsung_pay.png';
import applePayMark from '@/assets/apple-pay-mark.svg';
import linePayMark from '@/assets/line-pay-mark.png';
import mastercardMark from '@/assets/mastercard-mark.svg';

const PaymentIcons = () => (
  <>
    <span className="bg-white rounded px-2 py-1 inline-flex items-center">
      <svg className="h-6" viewBox="20 100 680 310" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M293.2 348.7l33.4-195.8h53.3l-33.4 195.8h-53.3z" fill="#00579F"/>
        <path d="M530.9 157.7c-10.5-4-27.1-8.3-47.7-8.3-52.6 0-89.7 26.6-89.9 64.7-.3 28.2 26.5 43.9 46.7 53.3 20.8 9.6 27.8 15.7 27.7 24.3-.1 13.1-16.6 19.1-31.9 19.1-21.4 0-32.7-3-50.3-10.2l-6.9-3.1-7.5 44c12.5 5.5 35.5 10.2 59.4 10.5 56 0 92.3-26.3 92.7-67 .2-22.3-14-39.3-44.7-53.3-18.6-9.1-30-15.1-29.9-24.3 0-8.1 9.6-16.8 30.4-16.8 17.4-.3 30 3.5 39.8 7.5l4.8 2.3 7.3-42.7z" fill="#00579F"/>
        <path d="M612.6 152.9h-41.2c-12.8 0-22.3 3.5-27.9 16.2l-79.2 179.6h56s9.2-24.2 11.2-29.5h68.4c1.6 6.9 6.5 29.5 6.5 29.5h49.5l-43.3-195.8zm-65.8 126.3c4.4-11.3 21.4-54.8 21.4-54.8-.3.5 4.4-11.4 7.1-18.8l3.6 17s10.3 47.1 12.4 56.6h-44.5z" fill="#00579F"/>
        <path d="M247.1 152.9l-52.2 133.5-5.6-27.1c-9.7-31.3-39.9-65.2-73.7-82.2l47.7 171.4h56.4l83.9-195.6h-56.5z" fill="#00579F"/>
        <path d="M146.9 152.9H59.6l-.7 3.8c66.9 16.2 111.2 55.5 129.5 102.6l-18.7-89.9c-3.2-12.3-12.7-16.1-22.8-16.5z" fill="#FAA61A"/>
      </svg>
    </span>
    <span className="bg-white rounded px-2 py-1 inline-flex items-center overflow-hidden">
      <img src={mastercardMark} alt="Mastercard" className="h-6 object-contain scale-[1.35]" />
    </span>
    <span className="bg-white rounded px-2 py-1 inline-flex items-center">
      <img src={applePayMark} alt="Apple Pay" className="h-6 object-contain" />
    </span>
    <span className="bg-white rounded px-2 py-1 inline-flex items-center">
      <img src={linePayMark} alt="LINE Pay" className="h-6 object-contain" />
    </span>
    <span className="bg-white rounded px-2 py-1 inline-flex items-center">
      <img src={googlePayMark} alt="Google Pay" className="h-6 object-contain" />
    </span>
    <span className="bg-white rounded px-2 py-1 inline-flex items-center">
      <img src={samsungPay} alt="Samsung Pay" className="h-6 object-contain" />
    </span>
  </>
);

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16 bg-background">

        {/* 上層：三欄佈局 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 lg:gap-12">
          {/* 第一欄：品牌識別 */}
          <div className="flex flex-col justify-between">
            <div>
              <h3 className="font-serif text-sm font-light tracking-[0.15em] mb-3">
                VELIREO SKIN
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed italic">
                Powered by probiotics, perfected by balance.
              </p>
              <p className="text-xs text-muted-foreground leading-relaxed mt-1">
                來自益菌的力量，成就肌膚的完美平衡。
              </p>
            </div>

            {/* 桌機/平板版付款方式圖示 */}
            <div className="hidden md:flex items-center gap-2 flex-wrap lg:flex-nowrap mt-6 lg:mt-auto">
              <PaymentIcons />
            </div>
          </div>

          {/* 第二欄：網站導覽 + 精選文章 */}
          <div className="md:justify-self-center lg:justify-self-end">
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3 text-foreground">
              網站導覽
            </h4>
            <ul className="list-stacked">
              {[
                { label: '首頁', to: '/' },
                { label: '產品', to: '/product-details' },
                { label: '優惠折扣', to: '/promotion' },
                { label: '品牌故事', to: '/brand-story' },
                { label: '保養文章', to: '/articles' },
                { label: '智能客服', to: '/ai-support' },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-xs text-muted-foreground hover:text-foreground transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="text-xs font-semibold uppercase tracking-wider mt-6 mb-3 text-foreground">
              精選文章
            </h4>
            <ul className="list-stacked">
              {[
                { label: '肌膚微生態完整指南', to: '/articles/skin-microbiome-guide' },
                { label: '益生菌護膚科學', to: '/articles/probiotic-skincare-guide' },
                { label: '2026 季節護膚策略', to: '/articles/seasonal-skincare-strategy-2026' },
                { label: '沐浴油霜質地全解析', to: '/articles/shower-cream-oil-texture-guide' },
                { label: '身體保養完整指南', to: '/articles/body-skincare-guide' },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-xs text-muted-foreground hover:text-foreground transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 第三欄：聯繫我們 + 公司資訊 */}
          <div className="lg:justify-self-end">
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3 text-foreground">
              聯繫我們
            </h4>
            <ul className="list-stacked">
              <li>
                <a href="https://lin.ee/4WzcOt7" target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
                  <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" /></svg>
                  官方 LINE
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/LazeCareLab/" target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
                  <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/lazecarelab/" target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
                  <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>
                  Instagram
                </a>
              </li>
            </ul>

            <div className="mt-6">
              <h4 className="text-xs font-semibold uppercase tracking-wider mb-3 text-foreground">
                公司資訊
              </h4>
              <ul className="list-stacked">
                <li className="text-xs text-muted-foreground">公司名稱：懶得保養研究室</li>
                <li className="text-xs text-muted-foreground">統一編號：00423095</li>
                <li className="text-xs text-muted-foreground">
                  聯絡信箱：<a href="mailto:service@lazecarelab.com" className="hover:text-foreground transition-colors">service@lazecarelab.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 手機版付款方式圖示 - 放在公司資訊下方 */}
        <div className="flex md:hidden items-center gap-2 flex-wrap mt-10">
          <PaymentIcons />
        </div>

        {/* 下層：政策連結 + 版權 */}
        <div className="mt-12 pt-6 border-t border-border/50 flex flex-col md:flex-row md:justify-between items-center gap-3">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Link to="/return-policy" className="hover:text-foreground transition-colors">退換貨政策</Link>
            <span className="text-muted-foreground/40">|</span>
            <Link to="/privacy-policy" className="hover:text-foreground transition-colors">隱私政策</Link>
            <span className="text-muted-foreground/40">|</span>
            <Link to="/terms-of-service" className="hover:text-foreground transition-colors">使用條款</Link>
          </div>
          <p className="text-xs text-muted-foreground">
            © 2026 Velireo Skin. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
